import { useState, useEffect } from "react";
import MainCarousel from "../../components/Landing/MainCarousel";
import PatientCard from "../../components/PaitientCard/PatientCard";
import styles from "./PatientInfo.module.scss";
import styled from "styled-components";

const data = [
  {
    title: "Last 3 Lab Tests",
    items: ["test1", "test2", "test3", "test1", "test2", "test3"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 Doctor's visits",
    items: ["Doctor 1", "Doctor 2", "Doctor 3"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 prescriptions",
    items: ["Prescription 1", "Prescription 2", "Prescription 3"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 clinic visits",
    items: ["Clinic", "Clinic", "Clinic"],
    tag: "ailments_symptoms",
  },
  {
    title: "Last 3 Procedures",
    items: ["Procedures", "Procedures", "Procedures"],
    tag: "ailments_symptoms",
  },
  {
    title: "Top 3 Reminders",
    items: ["Reminders", "Reminders", "Reminders"],
    tag: "assistances_services",
  },
  {
    title: "Top 3 Recommendations",
    items: ["Recommendations", "Recommendations", "Recommendations"],
    tag: "assistances_services",
  },
  {
    title: "Top 3 Trends",
    items: ["Trends", "Trends", "Trends"],
    tag: "assistances_services",
  },
  {
    title: "Top 3 Predictions",
    items: ["Predictions", "Predictions", "Predictions"],
    tag: "assistances_services",
  },
  {
    title: "Upcoming Appointments",
    items: ["Appointments", "Appointments", "Appointments"],
    tag: "assistances_services",
  },
  {
    title: "My Dietic & Nutrition",
    items: ["Diet", "Diet", "Diet"],
    tag: "general_recommendations",
  },
  {
    title: "Suggested reading on Lifestyles",
    items: ["read", "read", "read"],
    tag: "general_recommendations",
  },
  {
    title: "My Alternate Treatments",
    items: ["Treatments", "Treatments", "Treatments"],
    tag: "general_recommendations",
  },

  {
    title: "My Health Focus",
    items: ["Focus", "Focus", "Focus"],
    tag: "general_recommendations",
  },
  {
    title: "My Health Checks",
    items: ["Checks", "Checks", "Checks"],
    tag: "general_recommendations",
  },
  {
    title: "My Household",
    items: ["Household", "Household", "Household"],
    tag: "preferences",
  },
  {
    title: "My Health Trail",
    items: ["Trail", "Trail", "Trail"],
    tag: "preferences",
  },
  {
    title: "My Orders",
    items: ["Orders", "Orders", "Orders"],
    tag: "preferences",
  },
  {
    title: "My Hospitals, Doctors & Clinics",
    items: ["Clinics", "Clinics", "Clinics"],
    tag: "preferences",
  },
  {
    title: "My Settings",
    items: ["Settings", "Settings", "Settings"],
    tag: "preferences",
  },
];

const PatientInfo = ({ type,setSearchText }) => {
  const [cardData, setCardData] = useState(data);

  const handleFilter = (tag) => {
    if (tag === "all") {
      setCardData(data);
    } else {
      setCardData(data.filter((ele) => ele.tag === tag));
    }
  };

  return (
    <div>
      <MainCarousel type={type}  setSearchText={setSearchText}/>
      <h1 className={styles["page-title"]}>Health Dashboard</h1>
      <div id="accordion" class="mb-70">
              <div class="accordion-item ">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse3"  onClick={() => handleFilter("ailments_symptoms")}>
                  <a class="accordion__title" href="#">Ailments & Symptoms</a>
                </div>{/* <!-- /.accordion-item-header--> class="accordion__body" opened show*/}
                <div id="collapse3" class="collapse show" data-parent="#accordion">
                 
                  <div class="accordion__body health-dashboard-wrapper" >
                      {cardData.map((ele, i) => {
                        return (
                          <Card key={i} class="ailments_symptoms-card" style={{width: "90%",alignItems: "center",textAlign: "center",marginLeft: "5rem",marginBottom:"1rem",borderTop: "8px solid #21cdc0"}}>
                            <h6>{ele.title}</h6>
                            <ul>
                              {ele.items.map((item, idx) => (
                                <li key={idx}>{item}</li>
                              ))}
                            </ul>
                            <a href="#">more...</a>
                          </Card>
                        );
                      })}
                    </div>
                  {/* <!-- /.accordion-item-body--> */}
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse1" onClick={() => handleFilter("assistances_services")}>
                  <a class="accordion__title" href="#">Assistances & Services</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse1" class="collapse" data-parent="#accordion">
                <div class="accordion__body health-dashboard-wrapper">
                      {cardData.map((ele, i) => {
                        return (
                          <Card key={i} class="ailments_symptoms-card" style={{width: "90%",alignItems: "center",textAlign: "center",marginLeft: "5rem",marginBottom:"1rem",borderTop: "8px solid #21cdc0"}}>
                            <h6>{ele.title}</h6>
                            <ul>
                              {ele.items.map((item, idx) => (
                                <li key={idx}>{item}</li>
                              ))}
                            </ul>
                            <a href="#">more...</a>
                          </Card>
                        );
                      })}
                    </div>
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse7" onClick={() => handleFilter("general_recommendations")}>
                  <a class="accordion__title" href="#">Recommendations</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse7" class="collapse" data-parent="#accordion">
                  <div class="accordion__body">
                  <div class="accordion__body health-dashboard-wrapper">
                      {cardData.map((ele, i) => {
                        return (
                          <Card key={i} class="ailments_symptoms-card" style={{width: "90%",alignItems: "center",textAlign: "center",marginLeft: "5rem",marginBottom:"1rem",borderTop: "8px solid #21cdc0"}}>
                            <h6>{ele.title}</h6>
                            <ul>
                              {ele.items.map((item, idx) => (
                                <li key={idx}>{item}</li>
                              ))}
                            </ul>
                            <a href="#">more...</a>
                          </Card>
                        );
                      })}
                    </div>
                  </div>{/* <!-- /.accordion-item-body--> */}
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse2"  onClick={() => handleFilter("preferences")}>
                  <a class="accordion__title" href="#">Preferences</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse2" class="collapse" data-parent="#accordion">
                <div class="health-dashboard-wrapper">
                      {cardData.map((ele, i) => {
                        return (
                          <Card key={i} class="ailments_symptoms-card" style={{width: "90%",alignItems: "center",textAlign: "center",marginLeft: "5rem",marginBottom:"1rem",borderTop: "8px solid #21cdc0"}}>
                            <h6>{ele.title}</h6>
                            <ul>
                              {ele.items.map((item, idx) => (
                                <li key={idx}>{item}</li>
                              ))}
                            </ul>
                            <a href="#">more...</a>
                          </Card>
                        );
                      })}
                    </div>
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse4">
                  <a class="accordion__title" href="#">All</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse4" class="collapse" data-parent="#accordion">
                  <div class="accordion__body">
                  <div class="health-dashboard-wrapper">
                      {cardData.map((ele, i) => {
                        return (
                          <Card key={i} class="ailments_symptoms-card"  style={{width: "90%",alignItems: "center",textAlign: "center",marginLeft: "5rem",marginBottom:"1rem",borderTop: "8px solid #21cdc0"}}>
                            <h6>{ele.title}</h6>
                            <ul>
                              {ele.items.map((item, idx) => (
                                <li key={idx}>{item}</li>
                              ))}
                            </ul>
                            <a href="#">more...</a>
                          </Card>
                        );
                      })}
                    </div>
                  </div>{/* <!-- /.accordion-item-body--> */}
                </div>
              </div>{/* <!-- /.accordion-item--> */}
              <div class="accordion-item">
                <div class="accordion__header" data-toggle="collapse" data-target="#collapse5">
                  <a class="accordion__title" href="#">Any contracts or commitments?</a>
                </div>{/* <!-- /.accordion-item-header--> */}
                <div id="collapse5" class="collapse" data-parent="#accordion">
                <div class="accordion__body health-dashboard-wrapper">
                      {cardData.map((ele, i) => {
                        return (
                          <Card key={i} class="ailments_symptoms-card" style={{width: "90%",alignItems: "center",textAlign: "center",marginLeft: "5rem",marginBottom:"1rem",borderTop: "8px solid #21cdc0"}}>
                            <h6>{ele.title}</h6>
                            <ul>
                              {ele.items.map((item, idx) => (
                                <li key={idx}>{item}</li>
                              ))}
                            </ul>
                            <a href="#">more...</a>
                          </Card>
                        );
                      })}
                    </div>
                </div>
              </div>{/* <!-- /.accordion-item--> */}
            </div>
            {/*  <!-- /#accordion--> */} 
      {/* <div className={styles["content-wrapper"]}>
        <div className={styles["left-container"]}>
          <div className={styles["filter-container"]}>
            <button
              className={`${styles["ailments_symptoms"]} ${styles["filter"]} ${styles["filter"]}`}
              onClick={() => handleFilter("ailments_symptoms")}
            >
              Ailments & Symptoms
            </button>
            <button
              className={`${styles["assistances_services"]} ${styles["filter"]}`}
              onClick={() => handleFilter("assistances_services")}
            >
              Assistances & Services
            </button>
            <button
              className={`${styles["general_recommendations"]} ${styles["filter"]}`}
              onClick={() => handleFilter("general_recommendations")}
            >
              Assistances & Services
            </button>

            <button
              className={`${styles["preferences"]} ${styles["filter"]}`}
              onClick={() => handleFilter("preferences")}
            >
              Preferences
            </button>
            <button
              className={`${styles["all"]} ${styles["filter"]}`}
              onClick={() => handleFilter("all")}
            >
              All
            </button>
          </div>
          <div className={styles["health-dashboard-wrapper"]} style={{width: "90%",alignItems: "center",textAlign: "center",marginLeft: "5rem",marginBottom: "1rem"}}>
            {cardData.map((ele, i) => {
              return (
                <Card key={i} className={styles[ele.tag + "-card"]}>
                  <h6>{ele.title}</h6>
                  <ul>
                    {ele.items.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                  <a href="#">more...</a>
                </Card>
              );
            })}
          </div>
        </div>
        <div className={styles["right-container"]}>
          <PatientCard />
        </div>
      </div> */}
    </div>
  );
};

const Card = styled.div`
  background-color: white;
  border: 2px solid #d5d5d5;
  padding: 0.5rem;
  border-radius: 10px;
  flex-grow: 1;
  flex-basis: 46%;
  h6 {
    text-align: center;
    font-size: 1rem;
    margin-block: 3%;
  }
  ul {
    padding-left: 10%;
  }
  a {
    padding-left: 10%;
    color: #651fff !important;
  }
`;

export default PatientInfo;
